export default __webpack_public_path__ + "static/media/coventry-dark.61783713.png";